/*
 * @Author: Damon
 * @Date: 2020-11-20 15:05:08
 * @LastEditors: damon
 * @LastEditTime: 2024-06-24 16:09:30
 * @Description: file content
 */
/* eslint-disable no-use-before-define */
let LEADSPORTAL = '';
let AFTERSALESPORTAL = '';
let WEFFARECENTER = '';
let IDSSVC = '';
let ADVISORACTIVITY = '';
let ADVISORBINDINGPORTAL = '';
let IMPORTFILEDOWNLOAD = '';
let oAuthAccessToken = '';
let DESENSITIVE = false;
let PAYCENTER = '';
switch (process.env.NODE_ENV) {
  case 'development':
    LEADSPORTAL = window.config.leadsportal.qaUrl;
    AFTERSALESPORTAL = window.config.aftersalesportal.qaUrl;
    IDSSVC = window.config.idssvc.qaUrl;
    ADVISORACTIVITY = window.config.advisoractivity.qaUrl;
    ADVISORBINDINGPORTAL = window.config.advisorBindingPortal.qaUrl;
    IMPORTFILEDOWNLOAD = window.config.importFileDownLoad.qaUrl;
    // IMPORTFILEDOWNLOAD = window.config.importFileDownLoad.hotfixUrl;
    // oAuthAccessToken = '/leads.portal.hotfix/auth/token?isadmin=true';
    // oAuthAccessToken = '/leads.portal/auth/token?isadmin=true';
    oAuthAccessToken = '/test.portal/admin.user?isadmin=true';
    DESENSITIVE = window.config.desensitiveConfig.staging;
    PAYCENTER = window.config.paycenter.qaUrl;
    WEFFARECENTER = window.config.welfarecenter.qaUrl;
    break;
  case 'staging':
    LEADSPORTAL = window.config.leadsportal.qaUrl;
    AFTERSALESPORTAL = window.config.aftersalesportal.qaUrl;
    IDSSVC = window.config.idssvc.qaUrl;
    ADVISORACTIVITY = window.config.advisoractivity.qaUrl;
    ADVISORBINDINGPORTAL = window.config.advisorBindingPortal.qaUrl;
    IMPORTFILEDOWNLOAD = window.config.importFileDownLoad.qaUrl;
    // oAuthAccessToken = '/leads.portal/auth/token?isadmin=true';
    // oAuthAccessToken = '/user/GetUserResponse';
    oAuthAccessToken = '/user/GetUserResponse';
    DESENSITIVE = window.config.desensitiveConfig.staging;
    PAYCENTER = window.config.paycenter.qaUrl;
    WEFFARECENTER = window.config.welfarecenter.qaUrl;
    break;
  case 'preproduction':
    LEADSPORTAL = window.config.leadsportal.preProductUrl;
    AFTERSALESPORTAL = window.config.aftersalesportal.preProductUrl;
    IDSSVC = window.config.idssvc.preProductUrl;
    ADVISORACTIVITY = window.config.advisoractivity.preProductUrl;
    ADVISORBINDINGPORTAL = window.config.advisorBindingPortal.preProductUrl;
    IMPORTFILEDOWNLOAD = window.config.importFileDownLoad.preProductUrl;
    DESENSITIVE = window.config.desensitiveConfig.preproduction;
    oAuthAccessToken = '/user/GetUserResponse';
    PAYCENTER = window.config.paycenter.qaUrl;
    WEFFARECENTER = window.config.welfarecenter.preProductUrl;
    break;
  case 'hotfix':
    LEADSPORTAL = window.config.leadsportal.hotfixUrl;
    AFTERSALESPORTAL = window.config.aftersalesportal.qaUrl;
    IDSSVC = window.config.idssvc.qaUrl;
    ADVISORACTIVITY = window.config.advisoractivity.qaUrl;
    ADVISORBINDINGPORTAL = window.config.advisorBindingPortal.qaUrl;
    IMPORTFILEDOWNLOAD = window.config.importFileDownLoad.hotfixUrl;
    // oAuthAccessToken = '/leads.portal.hotfix/auth/token?isadmin=true';
    oAuthAccessToken = '/test.portal/admin.user?isadmin=true';
    DESENSITIVE = window.config.desensitiveConfig.hotfix;
    PAYCENTER = window.config.paycenter.qaUrl;
    WEFFARECENTER = window.config.welfarecenter.qaUrl;
    break;
  case 'production':
    LEADSPORTAL = window.config.leadsportal.productUrl;
    AFTERSALESPORTAL = window.config.aftersalesportal.productUrl;
    IDSSVC = window.config.idssvc.productUrl;
    ADVISORACTIVITY = window.config.advisoractivity.productUrl;
    ADVISORBINDINGPORTAL = window.config.advisorBindingPortal.productUrl;
    IMPORTFILEDOWNLOAD = window.config.importFileDownLoad.productUrl;
    oAuthAccessToken = '/user/GetUserResponse';
    DESENSITIVE = window.config.desensitiveConfig.production;
    PAYCENTER = window.config.paycenter.productUrl;
    WEFFARECENTER = window.config.welfarecenter.productUrl;
    break;
  default:
    break;
}
const urlServer = {
  IDSSVC,
  ADVISORACTIVITY,
  LEADSPORTAL,
  AFTERSALESPORTAL,
  ADVISORBINDINGPORTAL,
  IMPORTFILEDOWNLOAD,
  PAYCENTER,
  WEFFARECENTER,
};

const urlAPI = {
  guideJoinStore: `${urlServer.ADVISORBINDINGPORTAL}/Entry/joinStore`,
  guideExitStore: `${urlServer.IDSSVC}/Organization/store/guide/exit`,
  advisorList: `${urlServer.IDSSVC}/Organization/salesUser/getAll`,
  advisorDetail: `${urlServer.IDSSVC}/Organization/salesUser/find/`,
  advisorDetailByUserName: `${urlServer.IDSSVC}/Organization/salesUser/findByUserName/`,
  advisorModify: `${urlServer.IDSSVC}/Organization/salesUser/modify/`,
  advisorImport: `${urlServer.IDSSVC}/Organization/salesUser/import/`,
  advisorChangeReferrer: `${urlServer.IDSSVC}/Organization/salesUser/changeReferrer/`,
  advisorChangeGroup: `${urlServer.IDSSVC}/Organization/salesUser/changeGroup/`,
  advisorChangeSalesPermissionStatus: `${urlServer.IDSSVC}/Organization/salesUser/changeStatus/sales`,
  advisorSnapShot: `${urlServer.IDSSVC}/Organization/salesUser/getsnapshot`,
  regionSearch: `${urlServer.IDSSVC}/Map/GetRegionSearch`,
  activityPersonal: `${urlServer.ADVISORACTIVITY}/activity/personal`,
  activityTeam: `${urlServer.ADVISORACTIVITY}/activity/team`,
  activityTeamMembers: `${urlServer.ADVISORACTIVITY}/activity/team/members`,
  activityFinanceMonths: `${urlServer.ADVISORACTIVITY}/FinanceMonth/getFinanceMonths`,
  activityFinanceWeeks: `${urlServer.ADVISORACTIVITY}/FinanceMonth/getFinanceWeeks`,
  activityFinanceMonthLogs: `${urlServer.ADVISORACTIVITY}/FinanceMonth/getFinanceMonthLogs`,
  activityCategories: `${urlServer.ADVISORACTIVITY}/common/activity-categories`,
  attendanceList: `${urlServer.ADVISORACTIVITY}/attendance/list`,
  attendanceCreate: `${urlServer.ADVISORACTIVITY}/attendance`,
  attendanceDetail: `${urlServer.ADVISORACTIVITY}/attendance/`,
  attendanceUpdate: `${urlServer.ADVISORACTIVITY}/attendance/`,
  attendanceDelete: `${urlServer.ADVISORACTIVITY}/attendance/`,
  attendanceLogs: `${urlServer.ADVISORACTIVITY}/attendance/logs`,
  attendanceCategories: `${urlServer.ADVISORACTIVITY}/attendance/categories`,
  classRoomList: `${urlServer.ADVISORACTIVITY}/classroom/list`,
  classRoomReservationList: `${urlServer.ADVISORACTIVITY}/classroom/reservation/list`,
  classRoomCreate: `${urlServer.ADVISORACTIVITY}/classroom/create`,
  classRoomEdit: `${urlServer.ADVISORACTIVITY}/classroom/edit`,
  classRoomDelete: `${urlServer.ADVISORACTIVITY}/classroom/delete`,
  classRoomToggleVisable: `${urlServer.ADVISORACTIVITY}/classroom/toggleVisable`,
  classRoomReservationCancel: `${urlServer.ADVISORACTIVITY}/classroom/reservation/cancel`,
  branchList: `${urlServer.IDSSVC}/Organization/branch/getAll`,
  branchDetail: `${urlServer.IDSSVC}/Organization/branch/findByCode/`,
  branchAdd: `${urlServer.IDSSVC}/Organization/branch/add`,
  branchModify: `${urlServer.IDSSVC}/Organization/branch/modify/`,
  branchChangeManager: `${urlServer.IDSSVC}/Organization/branch/changeManager/`,
  branchChangeArea: `${urlServer.IDSSVC}/Organization/branch/changeArea`,
  studioList: `${urlServer.IDSSVC}/Organization/salesStudio/getAll`,
  studioAdd: `${urlServer.IDSSVC}/Organization/salesStudio/add`,
  studioGetByCode: `${urlServer.IDSSVC}/Organization/salesStudio/`,
  studioModify: `${urlServer.IDSSVC}/Organization/salesStudio/`,
  studioDispose: `${urlServer.IDSSVC}/Organization/salesStudio/dispose/`,
  studioRecover: `${urlServer.IDSSVC}/Organization/salesStudio/recover/`,
  teamList: `${urlServer.IDSSVC}/Organization/team/findByBranchCode/`,
  allTeamList: `${urlServer.IDSSVC}/Organization/team/getAll`,
  teamAdd: `${urlServer.IDSSVC}/Organization/team/add`,
  teamChangeBranch: `${urlServer.IDSSVC}/Organization/team/changeBranch`,
  teamTransferStatus: `${urlServer.IDSSVC}/Organization/team/transferStatus`,
  teamChangeManager: `${urlServer.IDSSVC}/Organization/team/changeManager`,
  storeModifyGuideLimit: `${urlServer.IDSSVC}/Organization/store/guideLimit`,
  storeDetail: `${urlServer.IDSSVC}/Organization/stores/find`,
  storeModify: `${urlServer.IDSSVC}/Organization/store/modify`,
  storeAdd: `${urlServer.IDSSVC}/Organization/store/add`,
  storeTransfer: `${urlServer.IDSSVC}/Organization/store/transfer`,
  storeClose: `${urlServer.IDSSVC}/Organization/store/close`,
  storeRecover: `${urlServer.IDSSVC}/Organization/store/recover`,
  areaList: `${urlServer.IDSSVC}/Organization/area/getAll`,
  areaAdd: `${urlServer.IDSSVC}/Organization/area/add`,
  areaModify: `${urlServer.IDSSVC}/Organization/area/modify`,
  areaChangeManager: `${urlServer.IDSSVC}/Organization/area/changeManager`,
  organizationRegionList: `${urlServer.IDSSVC}/Organization/region/getAll`,
  managerList: `${urlServer.IDSSVC}/Organization/salesUser/getAll`,
  salesUserTitleChangesLogList: `${urlServer.IDSSVC}/Organization/log/getSalesUserTitleChangesLog`,
  salesUserInfoChangesLogList: `${urlServer.IDSSVC}/Organization/log/getSalesUserInfoChangesLog`,
  salesUserRoadMapLogList: `${urlServer.IDSSVC}/Organization/log/getSalesUserRoadmapLog`,
  salesUserGroupChangesLogList: `${urlServer.IDSSVC}/Organization/log/getSalesUserGroupChangesLog`,
  salesUserStatusChangeLogList: `${urlServer.IDSSVC}/Organization/log/getSalesUserStatusChangeLog`,
  salesMemberBindingLogList: `${urlServer.IDSSVC}/Organization/log/getSalesMemberBindingLog`,
  salesGroupInfoChangesLogList: `${urlServer.IDSSVC}/Organization/log/getSalesGroupInfoChangesLog`,
  submitDistrictManager: `${urlServer.LEADSPORTAL}/ZoneWithoutStoreRelations`,
  editDistrictManager: `${urlServer.LEADSPORTAL}/ZoneWithoutStoreRelations/Edit`,
  removeDistrictManager: `${urlServer.LEADSPORTAL}/ZoneWithoutStoreRelations`,
  zoneManagerList: `${urlServer.LEADSPORTAL}/ZoneWithoutStoreRelations`,
  zoneManagerGetById: `${urlServer.LEADSPORTAL}/ZoneWithoutStoreRelations/GetById`,
  zoneManagerImport: `${urlServer.LEADSPORTAL}/ZoneWithoutStoreRelations/BatchImport`,
  leadList: `${urlServer.LEADSPORTAL}/Leads/getLeadList`,
  thirdPartySourceList: `${urlServer.LEADSPORTAL}/Leads/thirdPartySource`,
  miniProgramEnabled: `${urlServer.LEADSPORTAL}/Leads/miniProgramEnabled`,
  leadDetail: `${urlServer.LEADSPORTAL}/Leads/getLeadDetail`,
  leadClose: `${urlServer.LEADSPORTAL}/Leads/close/`,
  batchChangeManagers: `${urlServer.LEADSPORTAL}/Leads/batchChangeManagers`,
  uploadBannerFile: `${urlServer.LEADSPORTAL}/Banner/upload`,
  getBannerFile: `${urlServer.LEADSPORTAL}/Banner/strategy/get`,
  removeBannerFile: `${urlServer.LEADSPORTAL}/Banner/remove`,
  leadImport: `${urlServer.LEADSPORTAL}/LeadApplies/import`,
  leadSendSms: `${urlServer.LEADSPORTAL}/LeadApplies/sendLeadDataSms/`,
  advisorPromotionCandidateList: `${urlServer.ADVISORBINDINGPORTAL}/Entry/searchAdvisorPromotionCandidate`,
  advisorEntryCandidateList: `${urlServer.ADVISORBINDINGPORTAL}/Entry/searchAdvisorEntryCandidate`,
  storeCandidateList: `${urlServer.ADVISORBINDINGPORTAL}/Entry/searchStoreCandidate`,
  storeCandidateOperationList: `${urlServer.ADVISORBINDINGPORTAL}/Entry/searchStoreCandidateOperation`,
  storeCandidateInfoChangeLogs: `${urlServer.ADVISORBINDINGPORTAL}/Entry/searchStoreCandidateInfoChangeLogs`,
  storeCandidateReject: `${urlServer.ADVISORBINDINGPORTAL}/Entry/store/reject`,
  storeCandidateSign: `${urlServer.ADVISORBINDINGPORTAL}/Entry/storeCandidate/sign`,
  storeCandidateResendContract: `${urlServer.ADVISORBINDINGPORTAL}/Entry/store/resendContract`,
  advisorCandidateOperationList: `${urlServer.ADVISORBINDINGPORTAL}/Entry/searchOperation`,
  advisorNewPersonMissionOperationList: `${urlServer.ADVISORBINDINGPORTAL}/Entry/searchEntryMissionOperation`,
  advisorCandidateImport: `${urlServer.ADVISORBINDINGPORTAL}/Entry/freeLancer`,
  advisorCandidateValidate: `${urlServer.ADVISORBINDINGPORTAL}/Entry/freeLancer/validate`,
  advisormanualEntry: `${urlServer.ADVISORBINDINGPORTAL}/Entry/manualEntry`,
  initFinanceYear: `${urlServer.ADVISORACTIVITY}/FinanceMonth/initFinanceYear`,
  closeFinanceMonth: `${urlServer.ADVISORACTIVITY}/FinanceMonth/closeFinanceMonth`,
  advisorCandidateReject: `${urlServer.ADVISORBINDINGPORTAL}/Entry/rejectCandidate`,
  advisorPromotion: `${urlServer.ADVISORBINDINGPORTAL}/Entry/promotion`,
  advisorDemotion: `${urlServer.ADVISORBINDINGPORTAL}/Entry/demotion`,
  advisorPromotionReferrerTree: `${urlServer.ADVISORBINDINGPORTAL}/Entry/promotion/referrerTree`,
  advisorDemotionTeamLeader: `${urlServer.ADVISORBINDINGPORTAL}/Entry/demotion/teamLeader`,
  advisorTeamTransfer: `${urlServer.ADVISORBINDINGPORTAL}/Entry/teamTransfer`,
  advisorResign: `${urlServer.ADVISORBINDINGPORTAL}/Entry/advisorResign`,
  advisorReinstate: `${urlServer.ADVISORBINDINGPORTAL}/Entry/advisorReinstate`,
  fl2fte: `${urlServer.ADVISORBINDINGPORTAL}/Entry/Fl2FTE`,
  fl2sp: `${urlServer.ADVISORBINDINGPORTAL}/Entry/Fl2SP`,
  fte2sp: `${urlServer.ADVISORBINDINGPORTAL}/Entry/FTE2SP`,
  advisorRecordCreate: `${urlServer.ADVISORBINDINGPORTAL}/AdvisorRecord/CreateAdvisorRecord`,
  advisorRecordDelete: `${urlServer.ADVISORBINDINGPORTAL}/AdvisorRecord/DeleteAdvisorRecord`,
  advisorRecordQuery: `${urlServer.ADVISORBINDINGPORTAL}/AdvisorRecord/QueryAdvisorRecord`,
  advisorRecordSocialSecurityQuery: `${urlServer.ADVISORBINDINGPORTAL}/AdvisorRecord/GetAdvisorSocialSecurity`,
  missionSearchEntryMission: `${urlServer.ADVISORBINDINGPORTAL}/Mission/searchEntryMission`,
  missionApplySettling: `${urlServer.ADVISORBINDINGPORTAL}/Mission/ApplySettling`,
  missionChangeBalance: `${urlServer.ADVISORBINDINGPORTAL}/Mission/ChangeBalance`,
  advisorBindingList: `${urlServer.ADVISORBINDINGPORTAL}/Bindings/SearchBinding`,
  advisorBindingLogList: `${urlServer.ADVISORBINDINGPORTAL}/Bindings/SearchBindingLog`,
  advisorAdd: `${urlServer.ADVISORBINDINGPORTAL}/Bindings`,
  advisorDelete: `${urlServer.ADVISORBINDINGPORTAL}/Bindings`,
  advisorBatchRebind: `${urlServer.ADVISORBINDINGPORTAL}/Bindings/BatchRebind`,
  advisorModifyEntryDate: `${urlServer.ADVISORBINDINGPORTAL}/Advisor/ModifyEntryDate`,
  advisorModifyResignDate: `${urlServer.ADVISORBINDINGPORTAL}/Advisor/ModifyResignDate`,
  advisorReferrerTree: `${urlServer.ADVISORBINDINGPORTAL}/Advisor/AdvisorReferrerTree`,
  advisorTeamLeaderChains: `${urlServer.ADVISORBINDINGPORTAL}/Advisor/AdvisorTeamLeaderChains`,
  upload: `${urlServer.ADVISORBINDINGPORTAL}/Oss/Upload`,
  ambassadorList: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/search`,
  honorAmbassadorList: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/searchHonorAmbassadors`,
  honorAmbassadorRejectHonor: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/rejectHonor`,
  honorAmbassadorTerminateHonor: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/terminateHonor`,
  ambassadorOperationList: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/searchOperation`,
  ambassadorSign: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/signContract`,
  ambassadorAudit: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/audit`,
  ambassadorApplyManualSettle: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/applyManualSettle`,
  ambassadorTerminate: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/terminate`,
  ambassadorBlackUserList: `${urlServer.ADVISORBINDINGPORTAL}/BlackUser/blackusersearch`,
  ambassadorBlackUserRemove: `${urlServer.ADVISORBINDINGPORTAL}/BlackUser/removeBlackUser`,
  ambassadorCreateAmbassadorContract: `${urlServer.ADVISORBINDINGPORTAL}/Ambassador/createAmbassadorContract`,
  ambassadorBlackUserAdd: `${urlServer.ADVISORBINDINGPORTAL}/BlackUser/addBlackUser`,
  dashBoardPanelData: `${urlServer.LEADSPORTAL}/Leads/dashBoardPanelData`,
  dashBoardPieData: `${urlServer.LEADSPORTAL}/Leads/dashBoardPieData`,
  dashBoardLineData: `${urlServer.LEADSPORTAL}/Leads/dashBoardLineData`,
  dashBoardMapData: `${urlServer.LEADSPORTAL}/Leads/dashBoardMapData`,
  dashBoardMapProvinceData: `${urlServer.LEADSPORTAL}/Leads/dashBoardMapProvinceData`,
  oAuthAccessToken,
  desensitive: DESENSITIVE,
  //   支付中心
  instalmentList: `${urlServer.PAYCENTER}/schedule/instalment/get`,
  instalmentFindById: `${urlServer.PAYCENTER}/schedule/instalment/findById`,
  instalmentItemList: `${urlServer.PAYCENTER}/schedule/instalment/getItems`,
  instalmentDelete: `${urlServer.PAYCENTER}/schedule/instalment/delete`,
  instalmentItemDelete: `${urlServer.PAYCENTER}/schedule/instalment/deleteItem`,
  instalmentCreate: `${urlServer.PAYCENTER}/schedule/instalment/create`,
  instalmentModify: `${urlServer.PAYCENTER}/schedule/instalment/modify`,
  instalmentClone: `${urlServer.PAYCENTER}/schedule/instalment/clone`,
  instalmentItemCreate: `${urlServer.PAYCENTER}/schedule/instalment/createItem`,
  appIdList: `${urlServer.PAYCENTER}/config/app/getAll`,
  bankList: `${urlServer.PAYCENTER}/schedule/bank/getAll`,
  findActivatedByAppId: `${urlServer.PAYCENTER}/schedule/instalment/findActivatedByAppId`,
  paymentList: `${urlServer.PAYCENTER}/payment/get`,
  serviceOrderImport: `${urlServer.AFTERSALESPORTAL}/AfterSales/importOrder`,
  serviceOrderAdminAssignAndComplete: `${urlServer.AFTERSALESPORTAL}/AfterSales/adminAssignAndComplete`,
  serviceOrderSvcImgAudit: `${urlServer.AFTERSALESPORTAL}/AfterSales/auditSvcImg`,
  serviceOrderSvcFollowupAudit: `${urlServer.AFTERSALESPORTAL}/AfterSales/auditSvcFollowup`,
  serviceOrderAdminAssign: `${urlServer.AFTERSALESPORTAL}/AfterSales/adminAssign`,
  serviceOrderSearch: `${urlServer.AFTERSALESPORTAL}/AfterSales/search`,
  serviceOrderLog: `${urlServer.AFTERSALESPORTAL}/AfterSales/orderOperationLog`,
  serviceWorkflowLog: `${urlServer.AFTERSALESPORTAL}/AfterSales/workflowOperationLog`,

  welfareList: `${urlServer.WEFFARECENTER}/WelfareCenter/search`,
  demoKitPartList: `${urlServer.WEFFARECENTER}/DemoKitSuit/QueryDemoPartList`,
  demoKitSuitList: `${urlServer.WEFFARECENTER}/DemoKitSuit/QueryDemoKitSuitList`,
  demoKitInventory: `${urlServer.WEFFARECENTER}/DemoKitSuit/DemoKitInventory`,
  importDemoPart: `${urlServer.WEFFARECENTER}/DemoKitSuit/ImportDemoPart`,
  demoPartLogs: `${urlServer.WEFFARECENTER}/DemoKitSuit/QueryDemoPartLogs`,
  updateVoucherList: `${urlServer.WEFFARECENTER}/DemoKitSuit/UpdateDemoKitSuitVoucher`,
  demoKitSuitDetail: `${urlServer.WEFFARECENTER}/DemoKitSuit/QueryDemoKitSuitDetail`,
  deleteSuitVoucher: `${urlServer.WEFFARECENTER}/DemoKitSuit/DeleteDemoKitSuitVoucher`,
  advisorResaleQuotaList: `${urlServer.WEFFARECENTER}/ResaleQuota/QueryAdvisorResaleQuota`,
  resaleQuotaList: `${urlServer.WEFFARECENTER}/ResaleQuota/QueryResaleQuota`,
  importAdvisorResaleQuota: `${urlServer.WEFFARECENTER}/ResaleQuota/importAdvisorResaleQuota`,
  resaleQuotaLogList: `${urlServer.WEFFARECENTER}/ResaleQuota/QueryResaleQuotaLog`,
  uploadExpress: `${urlServer.WEFFARECENTER}/DemoKitSuit/UploadExpress`,
};

observe(urlServer);
observe(urlAPI);

function defineReactive(data, key, val) {
  observe(val);
  Object.defineProperty(data, key, {
    enumerable: true,
    configurable: false,
    get() {
      // if (key === 'HOST') {
      //   return val;
      // }
      // return this.HOST + val;
      return val;
    },
  });
}

function observe(data) {
  if (!data || typeof data !== 'object') {
    return;
  }
  Object.keys(data).forEach(key => {
    defineReactive(data, key, data[key]);
  });
}

export { urlServer, urlAPI };



// WEBPACK FOOTER //
// ./src/api/constAPI.js